import Graphics from 'js/core/Graphics';

class IframeMessagesController
{
  start(tweakpane)
  {
    this.tweakpane = tweakpane;
    this.bind_iframe_messages();

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', () =>
    {
      console.log('IFRAME: Preventing iframe back/forward navigation');

      // Prevent iframe back/forward navigation
      // window.history.pushState(null, '', window.location.href);

      parent.postMessage({ type: 'popstate' }, '*');
    });

    window.addEventListener('mousemove', (event) =>
    {
      // console.log('IFRAME: Mouse move event', event);
      parent.postMessage({ type: 'mousemove', x: event.clientX, y: event.clientY }, '*');
    });
  }

  on_enter()
  {
    parent.postMessage({ type: 'iframe_loaded' }, '*');  //  `*` on any domain
  }

  take_screenshot(callback)
  {
    Graphics.take_screenshot(callback, 256, 256);
  }

  toggle_tweakpane()
  {
    this.tweakpane.toggle();
  }

  bind_iframe_messages()
  {
    window.addEventListener('message', (event) =>
    {
    //   console.log('Message from parent:', event.data);
      if (event.data.type === 'take_screenshot')
      {
        // console.log('Taking screenshot');
        this.take_screenshot((blob) =>
        {
          //   console.log('Sending screenshot back to parent', event.source);
          // Send a response back to the parent window
          event.source.postMessage({ type: 'iframe_screenshot', screenshot: blob }, '*');
        });
      }
      else
      if (event.data.type === 'toggle_tweakpane')
      {
        this.toggle_tweakpane();
      }
    });
  }
}

const iframe_messages_controller = new IframeMessagesController();
module.exports = iframe_messages_controller;
